import { Utils } from '@genial/utils';

import { logoGenial } from '../../RateManagement/RequestDetails/exportPdf';

import {
  createDefaultInfoElements,
  createMainFieldsElements,
  defaultErrorMessage,
  getBackgroundColor,
  normalizeProductType,
  productItem,
} from './constants';
import { stylesPdf } from './stylesPdf';
import { defaultTransforms } from './transformer';
import { OrderPdfTypes, ProductTypeProps } from './types';

export const orderResumePdfTemplate = (data: OrderPdfTypes, productType: ProductTypeProps) => {
  const productTypeNormalized = normalizeProductType(productType, data);
  const defaultInfo = ['orderName', 'orderDate'].map((item) => ({
    label: defaultTransforms[item]?.label,
    value: defaultTransforms[item]?.value.call(data, productType) || defaultErrorMessage,
  }));

  const mappedMainFields = createMainFieldsElements(productTypeNormalized, data);

  const productTypeIsEquity = productTypeNormalized === 'Equity';
  const getOrderAmount = () => {
    const defaultAppliedValue =
      defaultTransforms.orderAmount?.value.call(data, productType) || defaultErrorMessage;
    const equitiesTotalAppliedValue = Utils.Mask.Money(data.orderAmount) || defaultErrorMessage;

    if (productTypeIsEquity) {
      return equitiesTotalAppliedValue;
    }
    return defaultAppliedValue;
  };

  const getOrderAmountLabel = () => {
    if (productTypeIsEquity || productTypeNormalized === 'StructuredOperations') {
      return 'Valor estimado';
    }
    return defaultTransforms.orderAmount?.label;
  };

  const orderAmount = getOrderAmount();
  const orderAmountLabel = getOrderAmountLabel();

  const styles = stylesPdf(getBackgroundColor(productTypeNormalized));
  const defaultInfoElements = createDefaultInfoElements(defaultInfo);

  const totalValueElementCode = `
    <div class="applied-row flex-container flex-row space-between radius-default">
      <span class="applied-label font-size-md font-weight-regular line-height-lg">${orderAmountLabel}</span>
      <span class="amount-value font-weight-bold font-size-md line-height-lg">${orderAmount}</span>
    </div>`;

  const shouldDisplayTotalValueElement =
    productTypeNormalized !== 'FixedIncomeRescue' &&
    productTypeNormalized !== 'FundRedemption' &&
    productTypeNormalized !== 'DirectTreasuryRescue';

  const totalValueElement = shouldDisplayTotalValueElement ? totalValueElementCode : '';

  return `
    <body>
    ${styles}
    <div class="container">
      <div class="flex-container space-between align-center">
        <strong class="font-size-lg line-height-lg font-weight-bold color-title">Boleta Enviada</strong>
        ${logoGenial}
      </div>
      <div class="line-box main-container">
        <div class="section-box radius-default">
          ${defaultInfoElements}
        </div>
      </div>
      <div class="flex-container align-center details-tab">
        <span class="font-size-sm font-weight-bold">
          Detalhe do produto
        </span>
      </div>
      <div class="flex-column main-container">
        <strong class="main-title font-weight-bold line-height-md font-size-md">${productItem[productTypeNormalized].title}</strong>
        <div class="full-width section-box radius-default investment-container">
          <div class="investment-sidebar"></div>
          ${mappedMainFields}
          ${totalValueElement}
        </div>
      </div>
    </div>
    </body>
  `;
};
